import * as React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Header } from "./header";
import { Box } from "@mui/material";
import { useMatch } from "react-router-dom";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMemo, useEffect, useRef } from "react";
import { isRunningInOutlook } from "@/taskpane/services/office";

export function Layout() {
  const { height } = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessedOAuth = useRef(false);

  const matchDiagram = useMatch("/filiation/:client_id/:dossier_id/:sous_dossier_id/:flow_id");
  const matchCallback = useMatch("/auth/sso/callback");

  const isOutlook = isRunningInOutlook();
  const isChat = useMatch("/folder/:folderId/:sousDossierId/chat");

  const isSmallScreen = useMemo(() => height ? height < 750 : false, [height]);

  // Detect OAuth callback parameters for cross-context SSO (Addin mode)
  // This handles the case where browser is already authenticated and bypasses login page
  useEffect(() => {
    // Only run once
    if (hasProcessedOAuth.current) return;
    
    // Don't intercept if already on callback page
    if (matchCallback) return;

    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    
    if (code && state) {
      console.log('[Layout] OAuth callback detected (cross-context SSO)');
      console.log('[Layout] Current route:', location.pathname);
      console.log('[Layout] Redirecting to callback handler to store tokens for Desktop Outlook');
      hasProcessedOAuth.current = true;
      navigate(`/auth/sso/callback${window.location.search}`, { replace: true });
    }
  }, [location.pathname, matchCallback, navigate]);

  return (
    <>
      
      <Box
        sx={{
        ...(matchDiagram || (!isOutlook && isChat)
          ?
          {
            width: (!isOutlook && isChat) ? "calc(100vw - 180px)" : "100%",
            "@media (max-width: 1200px)": {
              width: "calc(100vw - 50px)",
            },
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            px: 0
          }
          :
          {
            width: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            height: `calc(100vh-${isSmallScreen ? "40px" : "48px"})`,
            maxWidth: "800px",
            margin: "0 auto",
            ...(isSmallScreen ?
              {
                p: 0
              }
              :
              {
                paddingLeft: "4px",
                paddingRight: "4px",
                "@media (min-width: 550px)": {
                  paddingLeft: "24px",
                  paddingRight: "24px",
                }
              }
          )}),
      }}
    >
      {matchDiagram ? null : <Header />}
      <Box sx={isSmallScreen && !matchDiagram ? { flex: 1, flexDirection: "column",overflow: "hidden", flexGrow: 1 } : { flex: 1, overflow: "hidden", minHeight: 0}}>
        <Outlet />
      </Box>
    </Box>
    </>
  );
}
